module.exports = __webpack_public_path__ + "static/media/discover.d9276b56.png";